import {toApiModelFamilyFields} from 'features/vehicle-catalogue';

import type {BaseVehicle} from '../types/BaseVehicle';
import {getMakeValue} from './getMakeValue';

/**
 * Helper function to determine the correct modelFamily value based on custom make/model logic
 */
export const getModelFamilyValue = (
  formData: Pick<
    BaseVehicle,
    'make' | 'formMake' | 'customMake' | 'modelFamily' | 'formModelFamily' | 'customModelFamily'
  >
) =>
  toApiModelFamilyFields({
    make: getMakeValue(formData),
    modelFamily: formData.modelFamily,
    formModelFamily: formData.formModelFamily,
    customModelFamily: formData.customModelFamily,
  }).modelFamily;
